import {MappingEngineGetDetailsResp} from '@em/shared/api-interface';
import {
  Operator,
  OperatorGroups,
} from '@em/shared/mapping-engine/domain-models';
import {Flatten} from '@em/shared/util-types';

type avaialbe_backend_operators = NonNullable<
  Flatten<
    Flatten<
      Flatten<MappingEngineGetDetailsResp['attributes']>['rules']
    >['conditions']
  >
>['compare_operator'];

export const AvailableNumericOperators: Array<
  Operator & {name: avaialbe_backend_operators}
> = [
  {name: 'int_not_empty', type: 'integer', requireRightOperand: false},
  {name: 'int_is_empty', type: 'integer', requireRightOperand: false},
  {name: 'int_contains', type: 'integer', requireRightOperand: true},
  {name: 'int_not_contains', type: 'integer', requireRightOperand: true},
  {name: 'int_start_with', type: 'integer', requireRightOperand: true},
  {name: 'int_end_with', type: 'integer', requireRightOperand: true},
  {name: 'int_eq', type: 'integer', requireRightOperand: true},
  {name: 'int_neq', type: 'integer', requireRightOperand: true},
  {name: 'int_gt', type: 'integer', requireRightOperand: true},
  {name: 'int_ge', type: 'integer', requireRightOperand: true},
  {name: 'int_lt', type: 'integer', requireRightOperand: true},
  {name: 'int_le', type: 'integer', requireRightOperand: true},
];

export const AvailableStringOperators: Array<
  Operator & {name: avaialbe_backend_operators}
> = [
  {name: 'str_not_empty', type: 'string', requireRightOperand: false},
  {name: 'str_is_empty', type: 'string', requireRightOperand: false},
  {name: 'str_contains', type: 'string', requireRightOperand: true},
  {name: 'str_not_contains', type: 'string', requireRightOperand: true},
  {name: 'str_start_with', type: 'string', requireRightOperand: true},
  {name: 'str_end_with', type: 'string', requireRightOperand: true},
  {name: 'str_eq', type: 'string', requireRightOperand: true},
  {name: 'str_neq', type: 'string', requireRightOperand: true},
];

export const AvailableDateOperators: Array<
  Operator & {name: avaialbe_backend_operators}
> = [
  {name: 'date_not_empty', type: 'date', requireRightOperand: false},
  {name: 'date_is_empty', type: 'date', requireRightOperand: false},
  {name: 'date_eq', type: 'date', requireRightOperand: true},
  {name: 'date_neq', type: 'date', requireRightOperand: true},
  {name: 'date_gt', type: 'date', requireRightOperand: true},
  {name: 'date_ge', type: 'date', requireRightOperand: true},
  {name: 'date_lt', type: 'date', requireRightOperand: true},
  {name: 'date_le', type: 'date', requireRightOperand: true},
];

export const AvailableOperatorGroups: OperatorGroups = [
  {
    name: 'int',
    operators: AvailableNumericOperators,
  },
  {
    name: 'str',
    operators: AvailableStringOperators,
  },
  {
    name: 'date',
    operators: AvailableDateOperators,
  },
];
